import { ompApiClient } from "@app/config/axios/clients/ompApiClient";
import type { RequestConfig } from "@app/config/axios/http";
import type {
    ApiActOfCheckingAvailabilityContentData,
    ApiActOfCheckingAvailabilityContentUpdateFactQtyData,
    ApiActOfCheckingAvailabilityData,
    ActOfCheckingAvailabilityContentFilter,
    ActOfCheckingAvailabilityFilter,
} from "./types";

interface ActOfCheckingAvailabilityResponse {
    data: ApiActOfCheckingAvailabilityData[];
}

interface ActOfCheckingAvailabilityContentsResponse {
    data: ApiActOfCheckingAvailabilityContentData[];
}

interface ActOfCheckingAvailabilityContentInsertResponse {
    outData: ApiActOfCheckingAvailabilityContentData;
}

/** Транспортный слой OMP — АПН СУ и состав АПН для частичной инвентаризации склада. */
export const actOfCheckingAvailabilityApi = {
    /**
     * Загружает АПН СУ по фильтру.
     * @param params фильтр АПН
     * @param config опции HTTP-запроса
     */
    load: async (
        params: {
            flt?: ActOfCheckingAvailabilityFilter;
        },
        config?: RequestConfig,
    ): Promise<ApiActOfCheckingAvailabilityData[]> => {
        const data = await ompApiClient.postOmega<ActOfCheckingAvailabilityResponse>(
            "stock/actOfCheckingAvailability.loadByFilter",
            { flt: params.flt },
            config,
        );

        return data.data;
    },

    /** Состав АПН СУ. */
    content: {
        /**
         * Загружает строки состава АПН.
         * @param params фильтр состава АПН
         * @param config опции HTTP-запроса
         */
        load: async (
            params: {
                flt?: ActOfCheckingAvailabilityContentFilter;
            },
            config?: RequestConfig,
        ): Promise<ApiActOfCheckingAvailabilityContentData[]> => {
            const data = await ompApiClient.postOmega<ActOfCheckingAvailabilityContentsResponse>(
                "stock/actOfCheckingAvailability/contents.loadByFilter",
                { flt: params.flt },
                config,
            );

            return data.data;
        },

        /**
         * Добавляет строку состава АПН.
         * @param params данные добавляемой строки
         * @param config опции HTTP-запроса
         */
        insert: async (
            params: {
                data: ApiActOfCheckingAvailabilityContentData;
            },
            config?: RequestConfig,
        ): Promise<ApiActOfCheckingAvailabilityContentData> => {
            const response = await ompApiClient.postOmega<ActOfCheckingAvailabilityContentInsertResponse>(
                "stock/actOfCheckingAvailability/contents.insert",
                { data: params.data },
                config,
            );

            return response.outData;
        },

        /**
         * Обновляет фактические количества по строкам состава АПН.
         * @param params данные фактических количеств
         * @param config опции HTTP-запроса
         */
        updateFactQties: async (
            params: {
                qties: ApiActOfCheckingAvailabilityContentUpdateFactQtyData[];
            },
            config?: RequestConfig,
        ): Promise<void> => {
            await ompApiClient.postOmega(
                "stock/actOfCheckingAvailability/contents.updateFactQties",
                { qties: params.qties },
                config,
            );
        },
    },
};
